// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/conversations/v1/conversations.proto" (package "c1.api.conversations.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Facets } from "../../search/v1/facet";
import { Any } from "../../../../google/protobuf/any";
import { Automation } from "../../automations/v1/automations";
import { Policy } from "../../policy/v1/policy";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Struct } from "../../../../google/protobuf/struct";
/**
 * @generated from protobuf message c1.api.conversations.v1.UIConversationsServiceCreateRequest
 */
export interface UIConversationsServiceCreateRequest {
    /**
     * The title of the conversation.
     *
     * @generated from protobuf field: string title = 1
     */
    title: string;
    /**
     * The description of the conversation.
     *
     * @generated from protobuf field: string description = 2
     */
    description: string;
    /**
     * The type of conversation, determines which agent and tools to use.
     * If unspecified, defaults to GENERAL.
     *
     * @generated from protobuf field: c1.api.conversations.v1.AgentConversationType type = 3
     */
    type: AgentConversationType;
    /**
     * Type-specific metadata. Validated by backend per type.
     * For CEL_HELPER: { "env": "ENV_POLICY_CONDITIONAL", "initial_expression": "..." }
     *
     * @generated from protobuf field: google.protobuf.Struct metadata = 4
     */
    metadata?: Struct;
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIConversationsServiceCreateResponse
 */
export interface UIConversationsServiceCreateResponse {
    /**
     * The conversation ID.
     *
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * The title of the conversation.
     *
     * @generated from protobuf field: string title = 2
     */
    title: string;
    /**
     * The description of the conversation.
     *
     * @generated from protobuf field: string description = 3
     */
    description: string;
    /**
     * The conversation created at timestamp.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4
     */
    createdAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIConversationsServiceDeleteRequest
 */
export interface UIConversationsServiceDeleteRequest {
    /**
     * The conversation ID.
     *
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIConversationsServiceDeleteResponse
 */
export interface UIConversationsServiceDeleteResponse {
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIConversationsServiceMutateRequest
 */
export interface UIConversationsServiceMutateRequest {
    /**
     * The conversation ID.
     *
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * The title of the conversation.
     *
     * @generated from protobuf field: string title = 2
     */
    title: string;
    /**
     * The description of the conversation.
     *
     * @generated from protobuf field: string description = 3
     */
    description: string;
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIConversationsServiceMutateResponse
 */
export interface UIConversationsServiceMutateResponse {
    /**
     * The conversation ID.
     *
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * The title of the conversation.
     *
     * @generated from protobuf field: string title = 2
     */
    title: string;
    /**
     * The description of the conversation.
     *
     * @generated from protobuf field: string description = 3
     */
    description: string;
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIMessagesServiceSendRequest
 */
export interface UIMessagesServiceSendRequest {
    /**
     * The conversation ID.
     *
     * @generated from protobuf field: string conversation_id = 1
     */
    conversationId: string;
    /**
     * The message to send.
     *
     * @generated from protobuf field: string message = 2
     */
    message: string;
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIMessagesServiceSendResponse
 */
export interface UIMessagesServiceSendResponse {
    /**
     * The message ID.
     *
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * The message content.
     *
     * @generated from protobuf field: string content = 2
     */
    content: string;
    /**
     * The message role.
     *
     * @generated from protobuf field: c1.api.conversations.v1.UIMessageRole role = 3
     */
    role: UIMessageRole;
    /**
     * The message created at timestamp.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4
     */
    createdAt?: Timestamp;
    /**
     * The conversation ID.
     *
     * @generated from protobuf field: string conversation_id = 5
     */
    conversationId: string;
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIMessagesServiceListRequest
 */
export interface UIMessagesServiceListRequest {
    /**
     * The conversation ID.
     *
     * @generated from protobuf field: string conversation_id = 1
     */
    conversationId: string;
    /**
     * The pagination token to fetch the next page of results.
     *
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * The number of results to return.
     *
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIMessageRef
 */
export interface UIMessageRef {
    /**
     * The conversation ID.
     *
     * @generated from protobuf field: string conversation_id = 1
     */
    conversationId: string;
    /**
     * The message ID.
     *
     * @generated from protobuf field: string id = 2
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.conversations.v1.ToolUseBlock
 */
export interface ToolUseBlock {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: string use_id = 2
     */
    useId: string;
    /**
     * @generated from protobuf field: string input = 3
     */
    input: string;
}
/**
 * @generated from protobuf message c1.api.conversations.v1.ToolResultBlock
 */
export interface ToolResultBlock {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: string use_id = 2
     */
    useId: string;
    /**
     * @generated from protobuf field: string result = 3
     */
    result: string;
    /**
     * @generated from protobuf field: bool error = 4
     */
    error: boolean;
}
/**
 * @generated from protobuf message c1.api.conversations.v1.TextBlock
 */
export interface TextBlock {
    /**
     * @generated from protobuf field: string value = 1
     */
    value: string;
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIMessageContentBlock
 */
export interface UIMessageContentBlock {
    /**
     * @generated from protobuf oneof: parts
     */
    parts: {
        oneofKind: "textBlock";
        /**
         * @generated from protobuf field: c1.api.conversations.v1.TextBlock text_block = 1
         */
        textBlock: TextBlock;
    } | {
        oneofKind: "toolUseBlock";
        /**
         * @generated from protobuf field: c1.api.conversations.v1.ToolUseBlock tool_use_block = 2
         */
        toolUseBlock: ToolUseBlock;
    } | {
        oneofKind: "toolResultBlock";
        /**
         * @generated from protobuf field: c1.api.conversations.v1.ToolResultBlock tool_result_block = 3
         */
        toolResultBlock: ToolResultBlock;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIMessageActionItem
 */
export interface UIMessageActionItem {
    /**
     * @generated from protobuf oneof: action_item
     */
    actionItem: {
        oneofKind: "accessRequestActionItem";
        /**
         * @generated from protobuf field: c1.api.conversations.v1.UIMessageActionItem.AccessRequest access_request_action_item = 1
         */
        accessRequestActionItem: UIMessageActionItem_AccessRequest;
    } | {
        oneofKind: "celExpressionActionItem";
        /**
         * @generated from protobuf field: c1.api.conversations.v1.UIMessageActionItem.CELExpression cel_expression_action_item = 2
         */
        celExpressionActionItem: UIMessageActionItem_CELExpression;
    } | {
        oneofKind: "csvMappingActionItem";
        /**
         * @generated from protobuf field: c1.api.conversations.v1.UIMessageActionItem.CSVMapping csv_mapping_action_item = 3
         */
        csvMappingActionItem: UIMessageActionItem_CSVMapping;
    } | {
        oneofKind: "policyDraftActionItem";
        /**
         * @generated from protobuf field: c1.api.conversations.v1.UIMessageActionItem.PolicyDraft policy_draft_action_item = 4
         */
        policyDraftActionItem: UIMessageActionItem_PolicyDraft;
    } | {
        oneofKind: "automationDraftActionItem";
        /**
         * @generated from protobuf field: c1.api.conversations.v1.UIMessageActionItem.AutomationDraft automation_draft_action_item = 5
         */
        automationDraftActionItem: UIMessageActionItem_AutomationDraft;
    } | {
        oneofKind: "pendingActionsPreviewActionItem";
        /**
         * @generated from protobuf field: c1.api.conversations.v1.UIMessageActionItem.PendingActionsPreview pending_actions_preview_action_item = 6
         */
        pendingActionsPreviewActionItem: UIMessageActionItem_PendingActionsPreview;
    } | {
        oneofKind: "functionDraftActionItem";
        /**
         * @generated from protobuf field: c1.api.conversations.v1.UIMessageActionItem.FunctionDraft function_draft_action_item = 7
         */
        functionDraftActionItem: UIMessageActionItem_FunctionDraft;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIMessageActionItem.AccessRequest
 */
export interface UIMessageActionItem_AccessRequest {
    /**
     * @generated from protobuf field: string subject_id = 1
     */
    subjectId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string entitlement_id = 3
     */
    entitlementId: string;
    /**
     * @generated from protobuf field: int64 duration = 4
     */
    duration: number;
    /**
     * @generated from protobuf field: string reason = 5
     */
    reason: string;
    /**
     * @generated from protobuf field: string application_display_name = 6
     */
    applicationDisplayName: string;
    /**
     * @generated from protobuf field: string entitlement_display_name = 7
     */
    entitlementDisplayName: string;
    /**
     * @generated from protobuf field: string subject_display_name = 8
     */
    subjectDisplayName: string;
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIMessageActionItem.CELExpression
 */
export interface UIMessageActionItem_CELExpression {
    /**
     * The CEL expression code
     *
     * @generated from protobuf field: string expression = 1
     */
    expression: string;
    /**
     * Explanation of what the expression does
     *
     * @generated from protobuf field: string explanation = 2
     */
    explanation: string;
    /**
     * Whether the expression passed validation
     *
     * @generated from protobuf field: bool is_valid = 3
     */
    isValid: boolean;
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIMessageActionItem.CSVMapping
 */
export interface UIMessageActionItem_CSVMapping {
    /**
     * Mapping from C1 target field names to source file column headers
     * e.g. {"user id": "EmpID", "email address": "Work Email"}
     *
     * @generated from protobuf field: map<string, string> column_mapping = 1
     */
    columnMapping: {
        [key: string]: string;
    };
    /**
     * Mapping from custom profile attribute names to source file column headers
     * e.g. {"job_title": "Title", "department": "Dept"}
     *
     * @generated from protobuf field: map<string, string> profile_attribute_mapping = 2
     */
    profileAttributeMapping: {
        [key: string]: string;
    };
    /**
     * Explanation of the mapping choices
     *
     * @generated from protobuf field: string explanation = 3
     */
    explanation: string;
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIMessageActionItem.PolicyDraft
 */
export interface UIMessageActionItem_PolicyDraft {
    /**
     * The complete policy in API format - ready to apply to form
     *
     * @generated from protobuf field: c1.api.policy.v1.Policy policy = 1
     */
    policy?: Policy;
    /**
     * Agent's explanation of what was built
     *
     * @generated from protobuf field: string explanation = 2
     */
    explanation: string;
    /**
     * Is this creating a new policy or updating existing?
     *
     * @generated from protobuf field: bool is_new = 3
     */
    isNew: boolean;
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIMessageActionItem.AutomationDraft
 */
export interface UIMessageActionItem_AutomationDraft {
    /**
     * The complete automation in API format - ready to apply
     *
     * @generated from protobuf field: c1.api.automations.v1.Automation automation = 1
     */
    automation?: Automation;
    /**
     * Agent's explanation of what was built
     *
     * @generated from protobuf field: string explanation = 2
     */
    explanation: string;
    /**
     * Is this creating a new automation or updating existing?
     *
     * @generated from protobuf field: bool is_new = 3
     */
    isNew: boolean;
}
/**
 * Preview of pending actions to be created in an access review
 *
 * @generated from protobuf message c1.api.conversations.v1.UIMessageActionItem.PendingActionsPreview
 */
export interface UIMessageActionItem_PendingActionsPreview {
    /**
     * Access review ID these actions belong to
     *
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * Number of certify actions that will be created
     *
     * @generated from protobuf field: int32 certify_count = 2
     */
    certifyCount: number;
    /**
     * Number of deny actions that will be created
     *
     * @generated from protobuf field: int32 deny_count = 3
     */
    denyCount: number;
    /**
     * Total number of tasks affected
     *
     * @generated from protobuf field: int32 total_count = 4
     */
    totalCount: number;
    /**
     * Agent's explanation of what was done
     *
     * @generated from protobuf field: string explanation = 5
     */
    explanation: string;
    /**
     * Whether the actions were actually created (vs preview only)
     *
     * @generated from protobuf field: bool actions_created = 6
     */
    actionsCreated: boolean;
    /**
     * Whether the actions were discarded (removed)
     *
     * @generated from protobuf field: bool actions_discarded = 7
     */
    actionsDiscarded: boolean;
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIMessageActionItem.FunctionDraft
 */
export interface UIMessageActionItem_FunctionDraft {
    /**
     * The function ID (for existing functions being edited, empty for new)
     *
     * @generated from protobuf field: string function_id = 1
     */
    functionId: string;
    /**
     * Display name of the function
     *
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * Description of the function
     *
     * @generated from protobuf field: string description = 3
     */
    description: string;
    /**
     * The generated code files (filename -> content)
     *
     * @generated from protobuf field: map<string, string> files = 4
     */
    files: {
        [key: string]: string;
    };
    /**
     * Agent's explanation of what was built
     *
     * @generated from protobuf field: string explanation = 5
     */
    explanation: string;
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIMessage
 */
export interface UIMessage {
    /**
     * The message ID.
     *
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * The message content.
     *
     * @generated from protobuf field: string content = 2
     */
    content: string;
    /**
     * The message role.
     *
     * @generated from protobuf field: c1.api.conversations.v1.UIMessageRole role = 3
     */
    role: UIMessageRole;
    /**
     * The message created at timestamp.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4
     */
    createdAt?: Timestamp;
    /**
     * The conversation ID.
     *
     * @generated from protobuf field: string conversation_id = 5
     */
    conversationId: string;
    /**
     * All the content blocks on the message.
     *
     * @generated from protobuf field: repeated c1.api.conversations.v1.UIMessageContentBlock blocks = 6
     */
    blocks: UIMessageContentBlock[];
    /**
     * The message type.
     *
     * @generated from protobuf field: c1.api.conversations.v1.UIMessageActionItem action_item = 7
     */
    actionItem?: UIMessageActionItem;
    /**
     * The message type.
     *
     * @generated from protobuf field: c1.api.conversations.v1.UIMessage.MessageType type = 8
     */
    type: UIMessage_MessageType;
    /**
     * The feedback for the message.
     *
     * @generated from protobuf field: c1.api.conversations.v1.UIMessageFeedback feedback = 9
     */
    feedback?: UIMessageFeedback;
}
/**
 * @generated from protobuf enum c1.api.conversations.v1.UIMessage.MessageType
 */
export enum UIMessage_MessageType {
    /**
     * @generated from protobuf enum value: MESSAGE_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: MESSAGE_TYPE_CONTENT = 1;
     */
    CONTENT = 1,
    /**
     * @generated from protobuf enum value: MESSAGE_TYPE_THINKING = 2;
     */
    THINKING = 2,
    /**
     * @generated from protobuf enum value: MESSAGE_TYPE_DEBUG = 3;
     */
    DEBUG = 3
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIMessagesServiceListResponse
 */
export interface UIMessagesServiceListResponse {
    /**
     * The list of messages.
     *
     * @generated from protobuf field: repeated c1.api.conversations.v1.UIMessage list = 1
     */
    list: UIMessage[];
    /**
     * The pagination token to fetch the next page of results.
     *
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIConversationRef
 */
export interface UIConversationRef {
    /**
     * The conversation ID.
     *
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIConversation
 */
export interface UIConversation {
    /**
     * The conversation ID.
     *
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * The conversation created at timestamp.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * The conversation updated at timestamp.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * Title of the conversation.
     *
     * @generated from protobuf field: string title = 4
     */
    title: string;
    /**
     * The description of the conversation.
     *
     * @generated from protobuf field: string description = 5
     */
    description: string;
    /**
     * The user ID.
     *
     * @generated from protobuf field: string user_id = 6
     */
    userId: string;
    /**
     * Ticket IDs created from this conversation.
     *
     * @generated from protobuf field: repeated string ticket_ids = 7
     */
    ticketIds: string[];
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIConversationView
 */
export interface UIConversationView {
    /**
     * The conversation.
     *
     * @generated from protobuf field: c1.api.conversations.v1.UIConversation conversation = 1
     */
    conversation?: UIConversation;
    /**
     * The user.
     *
     * @generated from protobuf field: string user_path = 2
     */
    userPath: string;
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIConversationExpandMask
 */
export interface UIConversationExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIMessagesSearchServiceSearchRequest
 */
export interface UIMessagesSearchServiceSearchRequest {
    /**
     * The conversation ID.
     *
     * @generated from protobuf field: string conversation_id = 1
     */
    conversationId: string;
    /**
     * The pagination token to fetch the next page of results.
     *
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * The number of results to return.
     *
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
    /**
     * The refs to search for.
     *
     * @generated from protobuf field: repeated c1.api.conversations.v1.UIMessageRef refs = 4
     */
    refs: UIMessageRef[];
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIMessagesSearchServiceSearchResponse
 */
export interface UIMessagesSearchServiceSearchResponse {
    /**
     * The list of messages.
     *
     * @generated from protobuf field: repeated c1.api.conversations.v1.UIMessage list = 1
     */
    list: UIMessage[];
    /**
     * The pagination token to fetch the next page of results.
     *
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.conversations.v1.SearchRequest
 */
export interface SearchRequest {
    /**
     * The pagination token to fetch the next page of results.
     *
     * @generated from protobuf field: string page_token = 1
     */
    pageToken: string;
    /**
     * The number of results to return.
     *
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * The expand mask.
     *
     * @generated from protobuf field: c1.api.conversations.v1.UIConversationExpandMask expand_mask = 4
     */
    expandMask?: UIConversationExpandMask;
    /**
     * Refs
     *
     * @generated from protobuf field: repeated c1.api.conversations.v1.UIConversationRef refs = 5
     */
    refs: UIConversationRef[];
    /**
     * The query to search for.
     *
     * @generated from protobuf field: string query = 6
     */
    query: string;
    /**
     * The user IDs to search for.
     *
     * @generated from protobuf field: repeated string user_ids = 7
     */
    userIds: string[];
}
/**
 * @generated from protobuf message c1.api.conversations.v1.SearchResponse
 */
export interface SearchResponse {
    /**
     * The list of conversations.
     *
     * @generated from protobuf field: repeated c1.api.conversations.v1.UIConversationView list = 1
     */
    list: UIConversationView[];
    /**
     * The pagination token to fetch the next page of results.
     *
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * The expanded data.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.conversations.v1.GetSearchTermsRequest
 */
export interface GetSearchTermsRequest {
    /**
     * @generated from protobuf field: c1.api.conversations.v1.SearchRequest search = 1
     */
    search?: SearchRequest;
    /**
     * @generated from protobuf field: c1.api.conversations.v1.GetSearchTermsRequest.TermType term = 2
     */
    term: GetSearchTermsRequest_TermType;
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: bool include_count = 4
     */
    includeCount: boolean;
}
/**
 * @generated from protobuf enum c1.api.conversations.v1.GetSearchTermsRequest.TermType
 */
export enum GetSearchTermsRequest_TermType {
    /**
     * @generated from protobuf enum value: UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: USER_IDS = 1;
     */
    USER_IDS = 1
}
/**
 * @generated from protobuf message c1.api.conversations.v1.GetSearchTermsResponse
 */
export interface GetSearchTermsResponse {
    /**
     * @generated from protobuf field: c1.api.search.v1.Facets facets = 1
     */
    facets?: Facets;
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIMessageFeedback
 */
export interface UIMessageFeedback {
    /**
     * The conversation ID.
     *
     * @generated from protobuf field: string conversation_id = 1
     */
    conversationId: string;
    /**
     * The message ID.
     *
     * @generated from protobuf field: string message_id = 2
     */
    messageId: string;
    /**
     * The feedback type (positive or negative).
     *
     * @generated from protobuf field: c1.api.conversations.v1.UIMessageFeedback.Sentiment sentiment = 4
     */
    sentiment: UIMessageFeedback_Sentiment;
    /**
     * The feedback text.
     *
     * @generated from protobuf field: string text = 5
     */
    text: string;
}
/**
 * @generated from protobuf enum c1.api.conversations.v1.UIMessageFeedback.Sentiment
 */
export enum UIMessageFeedback_Sentiment {
    /**
     * @generated from protobuf enum value: SENTIMENT_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: SENTIMENT_POSITIVE = 1;
     */
    POSITIVE = 1,
    /**
     * @generated from protobuf enum value: SENTIMENT_NEGATIVE = 2;
     */
    NEGATIVE = 2
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIMessagesServiceCreateFeedbackRequest
 */
export interface UIMessagesServiceCreateFeedbackRequest {
    /**
     * @generated from protobuf field: c1.api.conversations.v1.UIMessageFeedback feedback = 1
     */
    feedback?: UIMessageFeedback;
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIMessagesServiceCreateFeedbackResponse
 */
export interface UIMessagesServiceCreateFeedbackResponse {
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIConversationConfig
 */
export interface UIConversationConfig {
    /**
     * @generated from protobuf field: string admin_agent_user_id = 1
     */
    adminAgentUserId: string;
    /**
     * @generated from protobuf field: string end_user_agent_user_id = 2
     */
    endUserAgentUserId: string;
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIConversationsServiceGetConfigRequest
 */
export interface UIConversationsServiceGetConfigRequest {
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIConversationsServiceGetConfigResponse
 */
export interface UIConversationsServiceGetConfigResponse {
    /**
     * @generated from protobuf field: c1.api.conversations.v1.UIConversationConfig config = 1
     */
    config?: UIConversationConfig;
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIConversationsServiceMutateConfigRequest
 */
export interface UIConversationsServiceMutateConfigRequest {
    /**
     * @generated from protobuf field: c1.api.conversations.v1.UIConversationConfig config = 1
     */
    config?: UIConversationConfig;
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIConversationsServiceMutateConfigResponse
 */
export interface UIConversationsServiceMutateConfigResponse {
    /**
     * @generated from protobuf field: c1.api.conversations.v1.UIConversationConfig config = 1
     */
    config?: UIConversationConfig;
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIConversationsServiceListTicketBindingsRequest
 */
export interface UIConversationsServiceListTicketBindingsRequest {
    /**
     * @generated from protobuf field: string conversation_id = 1
     */
    conversationId: string;
    /**
     * The pagination token to fetch the next page of results.
     *
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * The number of results to return.
     *
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
}
/**
 * @generated from protobuf message c1.api.conversations.v1.UIConversationsServiceListTicketBindingsResponse
 */
export interface UIConversationsServiceListTicketBindingsResponse {
    /**
     * The list of ticket IDs.
     *
     * @generated from protobuf field: repeated string list = 1
     */
    list: string[];
    /**
     * The pagination token to fetch the next page of results.
     *
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * AgentConversationType determines the agent and tools used for processing
 *
 * @generated from protobuf enum c1.api.conversations.v1.AgentConversationType
 */
export enum AgentConversationType {
    /**
     * @generated from protobuf enum value: AGENT_CONVERSATION_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * General purpose router agent (existing behavior)
     *
     * @generated from protobuf enum value: AGENT_CONVERSATION_TYPE_GENERAL = 1;
     */
    GENERAL = 1,
    /**
     * CEL expression assistant
     *
     * @generated from protobuf enum value: AGENT_CONVERSATION_TYPE_CEL_HELPER = 2;
     */
    CEL_HELPER = 2,
    /**
     * CSV/Spreadsheet column mapping assistant
     *
     * @generated from protobuf enum value: AGENT_CONVERSATION_TYPE_CSV_MAPPER = 3;
     */
    CSV_MAPPER = 3,
    /**
     * Policy building/editing assistant
     *
     * @generated from protobuf enum value: AGENT_CONVERSATION_TYPE_POLICY_HELPER = 4;
     */
    POLICY_HELPER = 4,
    /**
     * Automation building/editing assistant
     *
     * @generated from protobuf enum value: AGENT_CONVERSATION_TYPE_AUTOMATION_HELPER = 5;
     */
    AUTOMATION_HELPER = 5,
    /**
     * Access review helper for bulk pending actions
     *
     * @generated from protobuf enum value: AGENT_CONVERSATION_TYPE_ACCESS_REVIEW_HELPER = 6;
     */
    ACCESS_REVIEW_HELPER = 6,
    /**
     * Function development assistant for writing and deploying functions
     *
     * @generated from protobuf enum value: AGENT_CONVERSATION_TYPE_FUNCTION_HELPER = 7;
     */
    FUNCTION_HELPER = 7
}
/**
 * @generated from protobuf enum c1.api.conversations.v1.UIMessageRole
 */
export enum UIMessageRole {
    /**
     * @generated from protobuf enum value: UI_MESSAGE_ROLE_UNSPECIFIED = 0;
     */
    UI_MESSAGE_ROLE_UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: UI_MESSAGE_ROLE_SYSTEM = 1;
     */
    UI_MESSAGE_ROLE_SYSTEM = 1,
    /**
     * @generated from protobuf enum value: UI_MESSAGE_ROLE_USER = 2;
     */
    UI_MESSAGE_ROLE_USER = 2,
    /**
     * @generated from protobuf enum value: UI_MESSAGE_ROLE_ASSISTANT = 3;
     */
    UI_MESSAGE_ROLE_ASSISTANT = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class UIConversationsServiceCreateRequest$Type extends MessageType<UIConversationsServiceCreateRequest> {
    constructor() {
        super("c1.api.conversations.v1.UIConversationsServiceCreateRequest", [
            { no: 1, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "type", kind: "enum", T: () => ["c1.api.conversations.v1.AgentConversationType", AgentConversationType, "AGENT_CONVERSATION_TYPE_"] },
            { no: 4, name: "metadata", kind: "message", T: () => Struct }
        ]);
    }
    create(value?: PartialMessage<UIConversationsServiceCreateRequest>): UIConversationsServiceCreateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.title = "";
        message.description = "";
        message.type = 0;
        if (value !== undefined)
            reflectionMergePartial<UIConversationsServiceCreateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIConversationsServiceCreateRequest): UIConversationsServiceCreateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string title */ 1:
                    message.title = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* c1.api.conversations.v1.AgentConversationType type */ 3:
                    message.type = reader.int32();
                    break;
                case /* google.protobuf.Struct metadata */ 4:
                    message.metadata = Struct.internalBinaryRead(reader, reader.uint32(), options, message.metadata);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIConversationsServiceCreateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string title = 1; */
        if (message.title !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.title);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* c1.api.conversations.v1.AgentConversationType type = 3; */
        if (message.type !== 0)
            writer.tag(3, WireType.Varint).int32(message.type);
        /* google.protobuf.Struct metadata = 4; */
        if (message.metadata)
            Struct.internalBinaryWrite(message.metadata, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIConversationsServiceCreateRequest
 */
export const UIConversationsServiceCreateRequest = new UIConversationsServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIConversationsServiceCreateResponse$Type extends MessageType<UIConversationsServiceCreateResponse> {
    constructor() {
        super("c1.api.conversations.v1.UIConversationsServiceCreateResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<UIConversationsServiceCreateResponse>): UIConversationsServiceCreateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.title = "";
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<UIConversationsServiceCreateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIConversationsServiceCreateResponse): UIConversationsServiceCreateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string title */ 2:
                    message.title = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 4:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIConversationsServiceCreateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string title = 2; */
        if (message.title !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.title);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* google.protobuf.Timestamp created_at = 4; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIConversationsServiceCreateResponse
 */
export const UIConversationsServiceCreateResponse = new UIConversationsServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIConversationsServiceDeleteRequest$Type extends MessageType<UIConversationsServiceDeleteRequest> {
    constructor() {
        super("c1.api.conversations.v1.UIConversationsServiceDeleteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<UIConversationsServiceDeleteRequest>): UIConversationsServiceDeleteRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<UIConversationsServiceDeleteRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIConversationsServiceDeleteRequest): UIConversationsServiceDeleteRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIConversationsServiceDeleteRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIConversationsServiceDeleteRequest
 */
export const UIConversationsServiceDeleteRequest = new UIConversationsServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIConversationsServiceDeleteResponse$Type extends MessageType<UIConversationsServiceDeleteResponse> {
    constructor() {
        super("c1.api.conversations.v1.UIConversationsServiceDeleteResponse", []);
    }
    create(value?: PartialMessage<UIConversationsServiceDeleteResponse>): UIConversationsServiceDeleteResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UIConversationsServiceDeleteResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIConversationsServiceDeleteResponse): UIConversationsServiceDeleteResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIConversationsServiceDeleteResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIConversationsServiceDeleteResponse
 */
export const UIConversationsServiceDeleteResponse = new UIConversationsServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIConversationsServiceMutateRequest$Type extends MessageType<UIConversationsServiceMutateRequest> {
    constructor() {
        super("c1.api.conversations.v1.UIConversationsServiceMutateRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UIConversationsServiceMutateRequest>): UIConversationsServiceMutateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.title = "";
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<UIConversationsServiceMutateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIConversationsServiceMutateRequest): UIConversationsServiceMutateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string title */ 2:
                    message.title = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIConversationsServiceMutateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string title = 2; */
        if (message.title !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.title);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIConversationsServiceMutateRequest
 */
export const UIConversationsServiceMutateRequest = new UIConversationsServiceMutateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIConversationsServiceMutateResponse$Type extends MessageType<UIConversationsServiceMutateResponse> {
    constructor() {
        super("c1.api.conversations.v1.UIConversationsServiceMutateResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UIConversationsServiceMutateResponse>): UIConversationsServiceMutateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.title = "";
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<UIConversationsServiceMutateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIConversationsServiceMutateResponse): UIConversationsServiceMutateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string title */ 2:
                    message.title = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIConversationsServiceMutateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string title = 2; */
        if (message.title !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.title);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIConversationsServiceMutateResponse
 */
export const UIConversationsServiceMutateResponse = new UIConversationsServiceMutateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIMessagesServiceSendRequest$Type extends MessageType<UIMessagesServiceSendRequest> {
    constructor() {
        super("c1.api.conversations.v1.UIMessagesServiceSendRequest", [
            { no: 1, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UIMessagesServiceSendRequest>): UIMessagesServiceSendRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.conversationId = "";
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial<UIMessagesServiceSendRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIMessagesServiceSendRequest): UIMessagesServiceSendRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string conversation_id */ 1:
                    message.conversationId = reader.string();
                    break;
                case /* string message */ 2:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIMessagesServiceSendRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string conversation_id = 1; */
        if (message.conversationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.conversationId);
        /* string message = 2; */
        if (message.message !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIMessagesServiceSendRequest
 */
export const UIMessagesServiceSendRequest = new UIMessagesServiceSendRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIMessagesServiceSendResponse$Type extends MessageType<UIMessagesServiceSendResponse> {
    constructor() {
        super("c1.api.conversations.v1.UIMessagesServiceSendResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "content", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "role", kind: "enum", T: () => ["c1.api.conversations.v1.UIMessageRole", UIMessageRole] },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UIMessagesServiceSendResponse>): UIMessagesServiceSendResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.content = "";
        message.role = 0;
        message.conversationId = "";
        if (value !== undefined)
            reflectionMergePartial<UIMessagesServiceSendResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIMessagesServiceSendResponse): UIMessagesServiceSendResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string content */ 2:
                    message.content = reader.string();
                    break;
                case /* c1.api.conversations.v1.UIMessageRole role */ 3:
                    message.role = reader.int32();
                    break;
                case /* google.protobuf.Timestamp created_at */ 4:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* string conversation_id */ 5:
                    message.conversationId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIMessagesServiceSendResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string content = 2; */
        if (message.content !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.content);
        /* c1.api.conversations.v1.UIMessageRole role = 3; */
        if (message.role !== 0)
            writer.tag(3, WireType.Varint).int32(message.role);
        /* google.protobuf.Timestamp created_at = 4; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string conversation_id = 5; */
        if (message.conversationId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.conversationId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIMessagesServiceSendResponse
 */
export const UIMessagesServiceSendResponse = new UIMessagesServiceSendResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIMessagesServiceListRequest$Type extends MessageType<UIMessagesServiceListRequest> {
    constructor() {
        super("c1.api.conversations.v1.UIMessagesServiceListRequest", [
            { no: 1, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } }
        ]);
    }
    create(value?: PartialMessage<UIMessagesServiceListRequest>): UIMessagesServiceListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.conversationId = "";
        message.pageToken = "";
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial<UIMessagesServiceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIMessagesServiceListRequest): UIMessagesServiceListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string conversation_id */ 1:
                    message.conversationId = reader.string();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIMessagesServiceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string conversation_id = 1; */
        if (message.conversationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.conversationId);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIMessagesServiceListRequest
 */
export const UIMessagesServiceListRequest = new UIMessagesServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIMessageRef$Type extends MessageType<UIMessageRef> {
    constructor() {
        super("c1.api.conversations.v1.UIMessageRef", [
            { no: 1, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[0-9]{1,19}$" } } } }
        ]);
    }
    create(value?: PartialMessage<UIMessageRef>): UIMessageRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.conversationId = "";
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<UIMessageRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIMessageRef): UIMessageRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string conversation_id */ 1:
                    message.conversationId = reader.string();
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIMessageRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string conversation_id = 1; */
        if (message.conversationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.conversationId);
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIMessageRef
 */
export const UIMessageRef = new UIMessageRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToolUseBlock$Type extends MessageType<ToolUseBlock> {
    constructor() {
        super("c1.api.conversations.v1.ToolUseBlock", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "use_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "input", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ToolUseBlock>): ToolUseBlock {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.useId = "";
        message.input = "";
        if (value !== undefined)
            reflectionMergePartial<ToolUseBlock>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolUseBlock): ToolUseBlock {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string use_id */ 2:
                    message.useId = reader.string();
                    break;
                case /* string input */ 3:
                    message.input = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToolUseBlock, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string use_id = 2; */
        if (message.useId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.useId);
        /* string input = 3; */
        if (message.input !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.input);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.ToolUseBlock
 */
export const ToolUseBlock = new ToolUseBlock$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToolResultBlock$Type extends MessageType<ToolResultBlock> {
    constructor() {
        super("c1.api.conversations.v1.ToolResultBlock", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "use_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "result", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "error", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ToolResultBlock>): ToolResultBlock {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.useId = "";
        message.result = "";
        message.error = false;
        if (value !== undefined)
            reflectionMergePartial<ToolResultBlock>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolResultBlock): ToolResultBlock {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string use_id */ 2:
                    message.useId = reader.string();
                    break;
                case /* string result */ 3:
                    message.result = reader.string();
                    break;
                case /* bool error */ 4:
                    message.error = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToolResultBlock, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string use_id = 2; */
        if (message.useId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.useId);
        /* string result = 3; */
        if (message.result !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.result);
        /* bool error = 4; */
        if (message.error !== false)
            writer.tag(4, WireType.Varint).bool(message.error);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.ToolResultBlock
 */
export const ToolResultBlock = new ToolResultBlock$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TextBlock$Type extends MessageType<TextBlock> {
    constructor() {
        super("c1.api.conversations.v1.TextBlock", [
            { no: 1, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TextBlock>): TextBlock {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.value = "";
        if (value !== undefined)
            reflectionMergePartial<TextBlock>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TextBlock): TextBlock {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string value */ 1:
                    message.value = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TextBlock, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string value = 1; */
        if (message.value !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.TextBlock
 */
export const TextBlock = new TextBlock$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIMessageContentBlock$Type extends MessageType<UIMessageContentBlock> {
    constructor() {
        super("c1.api.conversations.v1.UIMessageContentBlock", [
            { no: 1, name: "text_block", kind: "message", oneof: "parts", T: () => TextBlock },
            { no: 2, name: "tool_use_block", kind: "message", oneof: "parts", T: () => ToolUseBlock },
            { no: 3, name: "tool_result_block", kind: "message", oneof: "parts", T: () => ToolResultBlock }
        ]);
    }
    create(value?: PartialMessage<UIMessageContentBlock>): UIMessageContentBlock {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.parts = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<UIMessageContentBlock>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIMessageContentBlock): UIMessageContentBlock {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.conversations.v1.TextBlock text_block */ 1:
                    message.parts = {
                        oneofKind: "textBlock",
                        textBlock: TextBlock.internalBinaryRead(reader, reader.uint32(), options, (message.parts as any).textBlock)
                    };
                    break;
                case /* c1.api.conversations.v1.ToolUseBlock tool_use_block */ 2:
                    message.parts = {
                        oneofKind: "toolUseBlock",
                        toolUseBlock: ToolUseBlock.internalBinaryRead(reader, reader.uint32(), options, (message.parts as any).toolUseBlock)
                    };
                    break;
                case /* c1.api.conversations.v1.ToolResultBlock tool_result_block */ 3:
                    message.parts = {
                        oneofKind: "toolResultBlock",
                        toolResultBlock: ToolResultBlock.internalBinaryRead(reader, reader.uint32(), options, (message.parts as any).toolResultBlock)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIMessageContentBlock, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.conversations.v1.TextBlock text_block = 1; */
        if (message.parts.oneofKind === "textBlock")
            TextBlock.internalBinaryWrite(message.parts.textBlock, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.conversations.v1.ToolUseBlock tool_use_block = 2; */
        if (message.parts.oneofKind === "toolUseBlock")
            ToolUseBlock.internalBinaryWrite(message.parts.toolUseBlock, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.conversations.v1.ToolResultBlock tool_result_block = 3; */
        if (message.parts.oneofKind === "toolResultBlock")
            ToolResultBlock.internalBinaryWrite(message.parts.toolResultBlock, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIMessageContentBlock
 */
export const UIMessageContentBlock = new UIMessageContentBlock$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIMessageActionItem$Type extends MessageType<UIMessageActionItem> {
    constructor() {
        super("c1.api.conversations.v1.UIMessageActionItem", [
            { no: 1, name: "access_request_action_item", kind: "message", oneof: "actionItem", T: () => UIMessageActionItem_AccessRequest },
            { no: 2, name: "cel_expression_action_item", kind: "message", oneof: "actionItem", T: () => UIMessageActionItem_CELExpression },
            { no: 3, name: "csv_mapping_action_item", kind: "message", oneof: "actionItem", T: () => UIMessageActionItem_CSVMapping },
            { no: 4, name: "policy_draft_action_item", kind: "message", oneof: "actionItem", T: () => UIMessageActionItem_PolicyDraft },
            { no: 5, name: "automation_draft_action_item", kind: "message", oneof: "actionItem", T: () => UIMessageActionItem_AutomationDraft },
            { no: 6, name: "pending_actions_preview_action_item", kind: "message", oneof: "actionItem", T: () => UIMessageActionItem_PendingActionsPreview },
            { no: 7, name: "function_draft_action_item", kind: "message", oneof: "actionItem", T: () => UIMessageActionItem_FunctionDraft }
        ]);
    }
    create(value?: PartialMessage<UIMessageActionItem>): UIMessageActionItem {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.actionItem = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<UIMessageActionItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIMessageActionItem): UIMessageActionItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.conversations.v1.UIMessageActionItem.AccessRequest access_request_action_item */ 1:
                    message.actionItem = {
                        oneofKind: "accessRequestActionItem",
                        accessRequestActionItem: UIMessageActionItem_AccessRequest.internalBinaryRead(reader, reader.uint32(), options, (message.actionItem as any).accessRequestActionItem)
                    };
                    break;
                case /* c1.api.conversations.v1.UIMessageActionItem.CELExpression cel_expression_action_item */ 2:
                    message.actionItem = {
                        oneofKind: "celExpressionActionItem",
                        celExpressionActionItem: UIMessageActionItem_CELExpression.internalBinaryRead(reader, reader.uint32(), options, (message.actionItem as any).celExpressionActionItem)
                    };
                    break;
                case /* c1.api.conversations.v1.UIMessageActionItem.CSVMapping csv_mapping_action_item */ 3:
                    message.actionItem = {
                        oneofKind: "csvMappingActionItem",
                        csvMappingActionItem: UIMessageActionItem_CSVMapping.internalBinaryRead(reader, reader.uint32(), options, (message.actionItem as any).csvMappingActionItem)
                    };
                    break;
                case /* c1.api.conversations.v1.UIMessageActionItem.PolicyDraft policy_draft_action_item */ 4:
                    message.actionItem = {
                        oneofKind: "policyDraftActionItem",
                        policyDraftActionItem: UIMessageActionItem_PolicyDraft.internalBinaryRead(reader, reader.uint32(), options, (message.actionItem as any).policyDraftActionItem)
                    };
                    break;
                case /* c1.api.conversations.v1.UIMessageActionItem.AutomationDraft automation_draft_action_item */ 5:
                    message.actionItem = {
                        oneofKind: "automationDraftActionItem",
                        automationDraftActionItem: UIMessageActionItem_AutomationDraft.internalBinaryRead(reader, reader.uint32(), options, (message.actionItem as any).automationDraftActionItem)
                    };
                    break;
                case /* c1.api.conversations.v1.UIMessageActionItem.PendingActionsPreview pending_actions_preview_action_item */ 6:
                    message.actionItem = {
                        oneofKind: "pendingActionsPreviewActionItem",
                        pendingActionsPreviewActionItem: UIMessageActionItem_PendingActionsPreview.internalBinaryRead(reader, reader.uint32(), options, (message.actionItem as any).pendingActionsPreviewActionItem)
                    };
                    break;
                case /* c1.api.conversations.v1.UIMessageActionItem.FunctionDraft function_draft_action_item */ 7:
                    message.actionItem = {
                        oneofKind: "functionDraftActionItem",
                        functionDraftActionItem: UIMessageActionItem_FunctionDraft.internalBinaryRead(reader, reader.uint32(), options, (message.actionItem as any).functionDraftActionItem)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIMessageActionItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.conversations.v1.UIMessageActionItem.AccessRequest access_request_action_item = 1; */
        if (message.actionItem.oneofKind === "accessRequestActionItem")
            UIMessageActionItem_AccessRequest.internalBinaryWrite(message.actionItem.accessRequestActionItem, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.conversations.v1.UIMessageActionItem.CELExpression cel_expression_action_item = 2; */
        if (message.actionItem.oneofKind === "celExpressionActionItem")
            UIMessageActionItem_CELExpression.internalBinaryWrite(message.actionItem.celExpressionActionItem, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.conversations.v1.UIMessageActionItem.CSVMapping csv_mapping_action_item = 3; */
        if (message.actionItem.oneofKind === "csvMappingActionItem")
            UIMessageActionItem_CSVMapping.internalBinaryWrite(message.actionItem.csvMappingActionItem, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.conversations.v1.UIMessageActionItem.PolicyDraft policy_draft_action_item = 4; */
        if (message.actionItem.oneofKind === "policyDraftActionItem")
            UIMessageActionItem_PolicyDraft.internalBinaryWrite(message.actionItem.policyDraftActionItem, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.conversations.v1.UIMessageActionItem.AutomationDraft automation_draft_action_item = 5; */
        if (message.actionItem.oneofKind === "automationDraftActionItem")
            UIMessageActionItem_AutomationDraft.internalBinaryWrite(message.actionItem.automationDraftActionItem, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.conversations.v1.UIMessageActionItem.PendingActionsPreview pending_actions_preview_action_item = 6; */
        if (message.actionItem.oneofKind === "pendingActionsPreviewActionItem")
            UIMessageActionItem_PendingActionsPreview.internalBinaryWrite(message.actionItem.pendingActionsPreviewActionItem, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.conversations.v1.UIMessageActionItem.FunctionDraft function_draft_action_item = 7; */
        if (message.actionItem.oneofKind === "functionDraftActionItem")
            UIMessageActionItem_FunctionDraft.internalBinaryWrite(message.actionItem.functionDraftActionItem, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIMessageActionItem
 */
export const UIMessageActionItem = new UIMessageActionItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIMessageActionItem_AccessRequest$Type extends MessageType<UIMessageActionItem_AccessRequest> {
    constructor() {
        super("c1.api.conversations.v1.UIMessageActionItem.AccessRequest", [
            { no: 1, name: "subject_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "duration", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 5, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "application_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "entitlement_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "subject_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UIMessageActionItem_AccessRequest>): UIMessageActionItem_AccessRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.subjectId = "";
        message.appId = "";
        message.entitlementId = "";
        message.duration = 0;
        message.reason = "";
        message.applicationDisplayName = "";
        message.entitlementDisplayName = "";
        message.subjectDisplayName = "";
        if (value !== undefined)
            reflectionMergePartial<UIMessageActionItem_AccessRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIMessageActionItem_AccessRequest): UIMessageActionItem_AccessRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string subject_id */ 1:
                    message.subjectId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string entitlement_id */ 3:
                    message.entitlementId = reader.string();
                    break;
                case /* int64 duration */ 4:
                    message.duration = reader.int64().toNumber();
                    break;
                case /* string reason */ 5:
                    message.reason = reader.string();
                    break;
                case /* string application_display_name */ 6:
                    message.applicationDisplayName = reader.string();
                    break;
                case /* string entitlement_display_name */ 7:
                    message.entitlementDisplayName = reader.string();
                    break;
                case /* string subject_display_name */ 8:
                    message.subjectDisplayName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIMessageActionItem_AccessRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string subject_id = 1; */
        if (message.subjectId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.subjectId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string entitlement_id = 3; */
        if (message.entitlementId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.entitlementId);
        /* int64 duration = 4; */
        if (message.duration !== 0)
            writer.tag(4, WireType.Varint).int64(message.duration);
        /* string reason = 5; */
        if (message.reason !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.reason);
        /* string application_display_name = 6; */
        if (message.applicationDisplayName !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.applicationDisplayName);
        /* string entitlement_display_name = 7; */
        if (message.entitlementDisplayName !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.entitlementDisplayName);
        /* string subject_display_name = 8; */
        if (message.subjectDisplayName !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.subjectDisplayName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIMessageActionItem.AccessRequest
 */
export const UIMessageActionItem_AccessRequest = new UIMessageActionItem_AccessRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIMessageActionItem_CELExpression$Type extends MessageType<UIMessageActionItem_CELExpression> {
    constructor() {
        super("c1.api.conversations.v1.UIMessageActionItem.CELExpression", [
            { no: 1, name: "expression", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "explanation", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "is_valid", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UIMessageActionItem_CELExpression>): UIMessageActionItem_CELExpression {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expression = "";
        message.explanation = "";
        message.isValid = false;
        if (value !== undefined)
            reflectionMergePartial<UIMessageActionItem_CELExpression>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIMessageActionItem_CELExpression): UIMessageActionItem_CELExpression {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string expression */ 1:
                    message.expression = reader.string();
                    break;
                case /* string explanation */ 2:
                    message.explanation = reader.string();
                    break;
                case /* bool is_valid */ 3:
                    message.isValid = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIMessageActionItem_CELExpression, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string expression = 1; */
        if (message.expression !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.expression);
        /* string explanation = 2; */
        if (message.explanation !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.explanation);
        /* bool is_valid = 3; */
        if (message.isValid !== false)
            writer.tag(3, WireType.Varint).bool(message.isValid);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIMessageActionItem.CELExpression
 */
export const UIMessageActionItem_CELExpression = new UIMessageActionItem_CELExpression$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIMessageActionItem_CSVMapping$Type extends MessageType<UIMessageActionItem_CSVMapping> {
    constructor() {
        super("c1.api.conversations.v1.UIMessageActionItem.CSVMapping", [
            { no: 1, name: "column_mapping", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } },
            { no: 2, name: "profile_attribute_mapping", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } },
            { no: 3, name: "explanation", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UIMessageActionItem_CSVMapping>): UIMessageActionItem_CSVMapping {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.columnMapping = {};
        message.profileAttributeMapping = {};
        message.explanation = "";
        if (value !== undefined)
            reflectionMergePartial<UIMessageActionItem_CSVMapping>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIMessageActionItem_CSVMapping): UIMessageActionItem_CSVMapping {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* map<string, string> column_mapping */ 1:
                    this.binaryReadMap1(message.columnMapping, reader, options);
                    break;
                case /* map<string, string> profile_attribute_mapping */ 2:
                    this.binaryReadMap2(message.profileAttributeMapping, reader, options);
                    break;
                case /* string explanation */ 3:
                    message.explanation = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap1(map: UIMessageActionItem_CSVMapping["columnMapping"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof UIMessageActionItem_CSVMapping["columnMapping"] | undefined, val: UIMessageActionItem_CSVMapping["columnMapping"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.conversations.v1.UIMessageActionItem.CSVMapping.column_mapping");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    private binaryReadMap2(map: UIMessageActionItem_CSVMapping["profileAttributeMapping"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof UIMessageActionItem_CSVMapping["profileAttributeMapping"] | undefined, val: UIMessageActionItem_CSVMapping["profileAttributeMapping"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.conversations.v1.UIMessageActionItem.CSVMapping.profile_attribute_mapping");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: UIMessageActionItem_CSVMapping, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* map<string, string> column_mapping = 1; */
        for (let k of globalThis.Object.keys(message.columnMapping))
            writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.columnMapping[k]).join();
        /* map<string, string> profile_attribute_mapping = 2; */
        for (let k of globalThis.Object.keys(message.profileAttributeMapping))
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.profileAttributeMapping[k]).join();
        /* string explanation = 3; */
        if (message.explanation !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.explanation);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIMessageActionItem.CSVMapping
 */
export const UIMessageActionItem_CSVMapping = new UIMessageActionItem_CSVMapping$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIMessageActionItem_PolicyDraft$Type extends MessageType<UIMessageActionItem_PolicyDraft> {
    constructor() {
        super("c1.api.conversations.v1.UIMessageActionItem.PolicyDraft", [
            { no: 1, name: "policy", kind: "message", T: () => Policy },
            { no: 2, name: "explanation", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "is_new", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UIMessageActionItem_PolicyDraft>): UIMessageActionItem_PolicyDraft {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.explanation = "";
        message.isNew = false;
        if (value !== undefined)
            reflectionMergePartial<UIMessageActionItem_PolicyDraft>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIMessageActionItem_PolicyDraft): UIMessageActionItem_PolicyDraft {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.policy.v1.Policy policy */ 1:
                    message.policy = Policy.internalBinaryRead(reader, reader.uint32(), options, message.policy);
                    break;
                case /* string explanation */ 2:
                    message.explanation = reader.string();
                    break;
                case /* bool is_new */ 3:
                    message.isNew = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIMessageActionItem_PolicyDraft, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.policy.v1.Policy policy = 1; */
        if (message.policy)
            Policy.internalBinaryWrite(message.policy, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string explanation = 2; */
        if (message.explanation !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.explanation);
        /* bool is_new = 3; */
        if (message.isNew !== false)
            writer.tag(3, WireType.Varint).bool(message.isNew);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIMessageActionItem.PolicyDraft
 */
export const UIMessageActionItem_PolicyDraft = new UIMessageActionItem_PolicyDraft$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIMessageActionItem_AutomationDraft$Type extends MessageType<UIMessageActionItem_AutomationDraft> {
    constructor() {
        super("c1.api.conversations.v1.UIMessageActionItem.AutomationDraft", [
            { no: 1, name: "automation", kind: "message", T: () => Automation },
            { no: 2, name: "explanation", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "is_new", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UIMessageActionItem_AutomationDraft>): UIMessageActionItem_AutomationDraft {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.explanation = "";
        message.isNew = false;
        if (value !== undefined)
            reflectionMergePartial<UIMessageActionItem_AutomationDraft>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIMessageActionItem_AutomationDraft): UIMessageActionItem_AutomationDraft {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.automations.v1.Automation automation */ 1:
                    message.automation = Automation.internalBinaryRead(reader, reader.uint32(), options, message.automation);
                    break;
                case /* string explanation */ 2:
                    message.explanation = reader.string();
                    break;
                case /* bool is_new */ 3:
                    message.isNew = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIMessageActionItem_AutomationDraft, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.automations.v1.Automation automation = 1; */
        if (message.automation)
            Automation.internalBinaryWrite(message.automation, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string explanation = 2; */
        if (message.explanation !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.explanation);
        /* bool is_new = 3; */
        if (message.isNew !== false)
            writer.tag(3, WireType.Varint).bool(message.isNew);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIMessageActionItem.AutomationDraft
 */
export const UIMessageActionItem_AutomationDraft = new UIMessageActionItem_AutomationDraft$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIMessageActionItem_PendingActionsPreview$Type extends MessageType<UIMessageActionItem_PendingActionsPreview> {
    constructor() {
        super("c1.api.conversations.v1.UIMessageActionItem.PendingActionsPreview", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "certify_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "deny_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "explanation", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "actions_created", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "actions_discarded", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UIMessageActionItem_PendingActionsPreview>): UIMessageActionItem_PendingActionsPreview {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.certifyCount = 0;
        message.denyCount = 0;
        message.totalCount = 0;
        message.explanation = "";
        message.actionsCreated = false;
        message.actionsDiscarded = false;
        if (value !== undefined)
            reflectionMergePartial<UIMessageActionItem_PendingActionsPreview>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIMessageActionItem_PendingActionsPreview): UIMessageActionItem_PendingActionsPreview {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* int32 certify_count */ 2:
                    message.certifyCount = reader.int32();
                    break;
                case /* int32 deny_count */ 3:
                    message.denyCount = reader.int32();
                    break;
                case /* int32 total_count */ 4:
                    message.totalCount = reader.int32();
                    break;
                case /* string explanation */ 5:
                    message.explanation = reader.string();
                    break;
                case /* bool actions_created */ 6:
                    message.actionsCreated = reader.bool();
                    break;
                case /* bool actions_discarded */ 7:
                    message.actionsDiscarded = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIMessageActionItem_PendingActionsPreview, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* int32 certify_count = 2; */
        if (message.certifyCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.certifyCount);
        /* int32 deny_count = 3; */
        if (message.denyCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.denyCount);
        /* int32 total_count = 4; */
        if (message.totalCount !== 0)
            writer.tag(4, WireType.Varint).int32(message.totalCount);
        /* string explanation = 5; */
        if (message.explanation !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.explanation);
        /* bool actions_created = 6; */
        if (message.actionsCreated !== false)
            writer.tag(6, WireType.Varint).bool(message.actionsCreated);
        /* bool actions_discarded = 7; */
        if (message.actionsDiscarded !== false)
            writer.tag(7, WireType.Varint).bool(message.actionsDiscarded);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIMessageActionItem.PendingActionsPreview
 */
export const UIMessageActionItem_PendingActionsPreview = new UIMessageActionItem_PendingActionsPreview$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIMessageActionItem_FunctionDraft$Type extends MessageType<UIMessageActionItem_FunctionDraft> {
    constructor() {
        super("c1.api.conversations.v1.UIMessageActionItem.FunctionDraft", [
            { no: 1, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "files", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } },
            { no: 5, name: "explanation", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UIMessageActionItem_FunctionDraft>): UIMessageActionItem_FunctionDraft {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.functionId = "";
        message.displayName = "";
        message.description = "";
        message.files = {};
        message.explanation = "";
        if (value !== undefined)
            reflectionMergePartial<UIMessageActionItem_FunctionDraft>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIMessageActionItem_FunctionDraft): UIMessageActionItem_FunctionDraft {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string function_id */ 1:
                    message.functionId = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* map<string, string> files */ 4:
                    this.binaryReadMap4(message.files, reader, options);
                    break;
                case /* string explanation */ 5:
                    message.explanation = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap4(map: UIMessageActionItem_FunctionDraft["files"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof UIMessageActionItem_FunctionDraft["files"] | undefined, val: UIMessageActionItem_FunctionDraft["files"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.conversations.v1.UIMessageActionItem.FunctionDraft.files");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: UIMessageActionItem_FunctionDraft, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string function_id = 1; */
        if (message.functionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.functionId);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* map<string, string> files = 4; */
        for (let k of globalThis.Object.keys(message.files))
            writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.files[k]).join();
        /* string explanation = 5; */
        if (message.explanation !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.explanation);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIMessageActionItem.FunctionDraft
 */
export const UIMessageActionItem_FunctionDraft = new UIMessageActionItem_FunctionDraft$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIMessage$Type extends MessageType<UIMessage> {
    constructor() {
        super("c1.api.conversations.v1.UIMessage", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "content", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "role", kind: "enum", T: () => ["c1.api.conversations.v1.UIMessageRole", UIMessageRole] },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "blocks", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UIMessageContentBlock, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 7, name: "action_item", kind: "message", T: () => UIMessageActionItem },
            { no: 8, name: "type", kind: "enum", T: () => ["c1.api.conversations.v1.UIMessage.MessageType", UIMessage_MessageType, "MESSAGE_TYPE_"] },
            { no: 9, name: "feedback", kind: "message", T: () => UIMessageFeedback }
        ]);
    }
    create(value?: PartialMessage<UIMessage>): UIMessage {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.content = "";
        message.role = 0;
        message.conversationId = "";
        message.blocks = [];
        message.type = 0;
        if (value !== undefined)
            reflectionMergePartial<UIMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIMessage): UIMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string content */ 2:
                    message.content = reader.string();
                    break;
                case /* c1.api.conversations.v1.UIMessageRole role */ 3:
                    message.role = reader.int32();
                    break;
                case /* google.protobuf.Timestamp created_at */ 4:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* string conversation_id */ 5:
                    message.conversationId = reader.string();
                    break;
                case /* repeated c1.api.conversations.v1.UIMessageContentBlock blocks */ 6:
                    message.blocks.push(UIMessageContentBlock.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* c1.api.conversations.v1.UIMessageActionItem action_item */ 7:
                    message.actionItem = UIMessageActionItem.internalBinaryRead(reader, reader.uint32(), options, message.actionItem);
                    break;
                case /* c1.api.conversations.v1.UIMessage.MessageType type */ 8:
                    message.type = reader.int32();
                    break;
                case /* c1.api.conversations.v1.UIMessageFeedback feedback */ 9:
                    message.feedback = UIMessageFeedback.internalBinaryRead(reader, reader.uint32(), options, message.feedback);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string content = 2; */
        if (message.content !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.content);
        /* c1.api.conversations.v1.UIMessageRole role = 3; */
        if (message.role !== 0)
            writer.tag(3, WireType.Varint).int32(message.role);
        /* google.protobuf.Timestamp created_at = 4; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string conversation_id = 5; */
        if (message.conversationId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.conversationId);
        /* repeated c1.api.conversations.v1.UIMessageContentBlock blocks = 6; */
        for (let i = 0; i < message.blocks.length; i++)
            UIMessageContentBlock.internalBinaryWrite(message.blocks[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.conversations.v1.UIMessageActionItem action_item = 7; */
        if (message.actionItem)
            UIMessageActionItem.internalBinaryWrite(message.actionItem, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.conversations.v1.UIMessage.MessageType type = 8; */
        if (message.type !== 0)
            writer.tag(8, WireType.Varint).int32(message.type);
        /* c1.api.conversations.v1.UIMessageFeedback feedback = 9; */
        if (message.feedback)
            UIMessageFeedback.internalBinaryWrite(message.feedback, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIMessage
 */
export const UIMessage = new UIMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIMessagesServiceListResponse$Type extends MessageType<UIMessagesServiceListResponse> {
    constructor() {
        super("c1.api.conversations.v1.UIMessagesServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UIMessage },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UIMessagesServiceListResponse>): UIMessagesServiceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<UIMessagesServiceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIMessagesServiceListResponse): UIMessagesServiceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.conversations.v1.UIMessage list */ 1:
                    message.list.push(UIMessage.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIMessagesServiceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.conversations.v1.UIMessage list = 1; */
        for (let i = 0; i < message.list.length; i++)
            UIMessage.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIMessagesServiceListResponse
 */
export const UIMessagesServiceListResponse = new UIMessagesServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIConversationRef$Type extends MessageType<UIConversationRef> {
    constructor() {
        super("c1.api.conversations.v1.UIConversationRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<UIConversationRef>): UIConversationRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<UIConversationRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIConversationRef): UIConversationRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIConversationRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIConversationRef
 */
export const UIConversationRef = new UIConversationRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIConversation$Type extends MessageType<UIConversation> {
    constructor() {
        super("c1.api.conversations.v1.UIConversation", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "ticket_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UIConversation>): UIConversation {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.title = "";
        message.description = "";
        message.userId = "";
        message.ticketIds = [];
        if (value !== undefined)
            reflectionMergePartial<UIConversation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIConversation): UIConversation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* string title */ 4:
                    message.title = reader.string();
                    break;
                case /* string description */ 5:
                    message.description = reader.string();
                    break;
                case /* string user_id */ 6:
                    message.userId = reader.string();
                    break;
                case /* repeated string ticket_ids */ 7:
                    message.ticketIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIConversation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string title = 4; */
        if (message.title !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.title);
        /* string description = 5; */
        if (message.description !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.description);
        /* string user_id = 6; */
        if (message.userId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.userId);
        /* repeated string ticket_ids = 7; */
        for (let i = 0; i < message.ticketIds.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.ticketIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIConversation
 */
export const UIConversation = new UIConversation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIConversationView$Type extends MessageType<UIConversationView> {
    constructor() {
        super("c1.api.conversations.v1.UIConversationView", [
            { no: 1, name: "conversation", kind: "message", T: () => UIConversation },
            { no: 2, name: "user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UIConversationView>): UIConversationView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userPath = "";
        if (value !== undefined)
            reflectionMergePartial<UIConversationView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIConversationView): UIConversationView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.conversations.v1.UIConversation conversation */ 1:
                    message.conversation = UIConversation.internalBinaryRead(reader, reader.uint32(), options, message.conversation);
                    break;
                case /* string user_path */ 2:
                    message.userPath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIConversationView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.conversations.v1.UIConversation conversation = 1; */
        if (message.conversation)
            UIConversation.internalBinaryWrite(message.conversation, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string user_path = 2; */
        if (message.userPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userPath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIConversationView
 */
export const UIConversationView = new UIConversationView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIConversationExpandMask$Type extends MessageType<UIConversationExpandMask> {
    constructor() {
        super("c1.api.conversations.v1.UIConversationExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "user_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<UIConversationExpandMask>): UIConversationExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<UIConversationExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIConversationExpandMask): UIConversationExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIConversationExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIConversationExpandMask
 */
export const UIConversationExpandMask = new UIConversationExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIMessagesSearchServiceSearchRequest$Type extends MessageType<UIMessagesSearchServiceSearchRequest> {
    constructor() {
        super("c1.api.conversations.v1.UIMessagesSearchServiceSearchRequest", [
            { no: 1, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UIMessageRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
    create(value?: PartialMessage<UIMessagesSearchServiceSearchRequest>): UIMessagesSearchServiceSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.conversationId = "";
        message.pageToken = "";
        message.pageSize = 0;
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<UIMessagesSearchServiceSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIMessagesSearchServiceSearchRequest): UIMessagesSearchServiceSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string conversation_id */ 1:
                    message.conversationId = reader.string();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                case /* repeated c1.api.conversations.v1.UIMessageRef refs */ 4:
                    message.refs.push(UIMessageRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIMessagesSearchServiceSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string conversation_id = 1; */
        if (message.conversationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.conversationId);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        /* repeated c1.api.conversations.v1.UIMessageRef refs = 4; */
        for (let i = 0; i < message.refs.length; i++)
            UIMessageRef.internalBinaryWrite(message.refs[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIMessagesSearchServiceSearchRequest
 */
export const UIMessagesSearchServiceSearchRequest = new UIMessagesSearchServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIMessagesSearchServiceSearchResponse$Type extends MessageType<UIMessagesSearchServiceSearchResponse> {
    constructor() {
        super("c1.api.conversations.v1.UIMessagesSearchServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UIMessage },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UIMessagesSearchServiceSearchResponse>): UIMessagesSearchServiceSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<UIMessagesSearchServiceSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIMessagesSearchServiceSearchResponse): UIMessagesSearchServiceSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.conversations.v1.UIMessage list */ 1:
                    message.list.push(UIMessage.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIMessagesSearchServiceSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.conversations.v1.UIMessage list = 1; */
        for (let i = 0; i < message.list.length; i++)
            UIMessage.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIMessagesSearchServiceSearchResponse
 */
export const UIMessagesSearchServiceSearchResponse = new UIMessagesSearchServiceSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchRequest$Type extends MessageType<SearchRequest> {
    constructor() {
        super("c1.api.conversations.v1.SearchRequest", [
            { no: 1, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 10 } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => UIConversationExpandMask },
            { no: 5, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UIConversationRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 6, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 7, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<SearchRequest>): SearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageToken = "";
        message.pageSize = 0;
        message.refs = [];
        message.query = "";
        message.userIds = [];
        if (value !== undefined)
            reflectionMergePartial<SearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchRequest): SearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string page_token */ 1:
                    message.pageToken = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* c1.api.conversations.v1.UIConversationExpandMask expand_mask */ 4:
                    message.expandMask = UIConversationExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* repeated c1.api.conversations.v1.UIConversationRef refs */ 5:
                    message.refs.push(UIConversationRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string query */ 6:
                    message.query = reader.string();
                    break;
                case /* repeated string user_ids */ 7:
                    message.userIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string page_token = 1; */
        if (message.pageToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.pageToken);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* c1.api.conversations.v1.UIConversationExpandMask expand_mask = 4; */
        if (message.expandMask)
            UIConversationExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.conversations.v1.UIConversationRef refs = 5; */
        for (let i = 0; i < message.refs.length; i++)
            UIConversationRef.internalBinaryWrite(message.refs[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string query = 6; */
        if (message.query !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.query);
        /* repeated string user_ids = 7; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.userIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.SearchRequest
 */
export const SearchRequest = new SearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchResponse$Type extends MessageType<SearchResponse> {
    constructor() {
        super("c1.api.conversations.v1.SearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UIConversationView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<SearchResponse>): SearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<SearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchResponse): SearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.conversations.v1.UIConversationView list */ 1:
                    message.list.push(UIConversationView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.conversations.v1.UIConversationView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            UIConversationView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.SearchResponse
 */
export const SearchResponse = new SearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSearchTermsRequest$Type extends MessageType<GetSearchTermsRequest> {
    constructor() {
        super("c1.api.conversations.v1.GetSearchTermsRequest", [
            { no: 1, name: "search", kind: "message", T: () => SearchRequest },
            { no: 2, name: "term", kind: "enum", T: () => ["c1.api.conversations.v1.GetSearchTermsRequest.TermType", GetSearchTermsRequest_TermType] },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "include_count", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<GetSearchTermsRequest>): GetSearchTermsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.term = 0;
        message.query = "";
        message.includeCount = false;
        if (value !== undefined)
            reflectionMergePartial<GetSearchTermsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSearchTermsRequest): GetSearchTermsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.conversations.v1.SearchRequest search */ 1:
                    message.search = SearchRequest.internalBinaryRead(reader, reader.uint32(), options, message.search);
                    break;
                case /* c1.api.conversations.v1.GetSearchTermsRequest.TermType term */ 2:
                    message.term = reader.int32();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* bool include_count */ 4:
                    message.includeCount = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSearchTermsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.conversations.v1.SearchRequest search = 1; */
        if (message.search)
            SearchRequest.internalBinaryWrite(message.search, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.conversations.v1.GetSearchTermsRequest.TermType term = 2; */
        if (message.term !== 0)
            writer.tag(2, WireType.Varint).int32(message.term);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* bool include_count = 4; */
        if (message.includeCount !== false)
            writer.tag(4, WireType.Varint).bool(message.includeCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.GetSearchTermsRequest
 */
export const GetSearchTermsRequest = new GetSearchTermsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSearchTermsResponse$Type extends MessageType<GetSearchTermsResponse> {
    constructor() {
        super("c1.api.conversations.v1.GetSearchTermsResponse", [
            { no: 1, name: "facets", kind: "message", T: () => Facets },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetSearchTermsResponse>): GetSearchTermsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<GetSearchTermsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSearchTermsResponse): GetSearchTermsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.search.v1.Facets facets */ 1:
                    message.facets = Facets.internalBinaryRead(reader, reader.uint32(), options, message.facets);
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSearchTermsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.search.v1.Facets facets = 1; */
        if (message.facets)
            Facets.internalBinaryWrite(message.facets, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.GetSearchTermsResponse
 */
export const GetSearchTermsResponse = new GetSearchTermsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIMessageFeedback$Type extends MessageType<UIMessageFeedback> {
    constructor() {
        super("c1.api.conversations.v1.UIMessageFeedback", [
            { no: 1, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "message_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[0-9]{1,19}$" } } } },
            { no: 4, name: "sentiment", kind: "enum", T: () => ["c1.api.conversations.v1.UIMessageFeedback.Sentiment", UIMessageFeedback_Sentiment, "SENTIMENT_"] },
            { no: 5, name: "text", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "2000" } } } }
        ]);
    }
    create(value?: PartialMessage<UIMessageFeedback>): UIMessageFeedback {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.conversationId = "";
        message.messageId = "";
        message.sentiment = 0;
        message.text = "";
        if (value !== undefined)
            reflectionMergePartial<UIMessageFeedback>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIMessageFeedback): UIMessageFeedback {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string conversation_id */ 1:
                    message.conversationId = reader.string();
                    break;
                case /* string message_id */ 2:
                    message.messageId = reader.string();
                    break;
                case /* c1.api.conversations.v1.UIMessageFeedback.Sentiment sentiment */ 4:
                    message.sentiment = reader.int32();
                    break;
                case /* string text */ 5:
                    message.text = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIMessageFeedback, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string conversation_id = 1; */
        if (message.conversationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.conversationId);
        /* string message_id = 2; */
        if (message.messageId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.messageId);
        /* c1.api.conversations.v1.UIMessageFeedback.Sentiment sentiment = 4; */
        if (message.sentiment !== 0)
            writer.tag(4, WireType.Varint).int32(message.sentiment);
        /* string text = 5; */
        if (message.text !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.text);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIMessageFeedback
 */
export const UIMessageFeedback = new UIMessageFeedback$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIMessagesServiceCreateFeedbackRequest$Type extends MessageType<UIMessagesServiceCreateFeedbackRequest> {
    constructor() {
        super("c1.api.conversations.v1.UIMessagesServiceCreateFeedbackRequest", [
            { no: 1, name: "feedback", kind: "message", T: () => UIMessageFeedback }
        ]);
    }
    create(value?: PartialMessage<UIMessagesServiceCreateFeedbackRequest>): UIMessagesServiceCreateFeedbackRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UIMessagesServiceCreateFeedbackRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIMessagesServiceCreateFeedbackRequest): UIMessagesServiceCreateFeedbackRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.conversations.v1.UIMessageFeedback feedback */ 1:
                    message.feedback = UIMessageFeedback.internalBinaryRead(reader, reader.uint32(), options, message.feedback);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIMessagesServiceCreateFeedbackRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.conversations.v1.UIMessageFeedback feedback = 1; */
        if (message.feedback)
            UIMessageFeedback.internalBinaryWrite(message.feedback, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIMessagesServiceCreateFeedbackRequest
 */
export const UIMessagesServiceCreateFeedbackRequest = new UIMessagesServiceCreateFeedbackRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIMessagesServiceCreateFeedbackResponse$Type extends MessageType<UIMessagesServiceCreateFeedbackResponse> {
    constructor() {
        super("c1.api.conversations.v1.UIMessagesServiceCreateFeedbackResponse", []);
    }
    create(value?: PartialMessage<UIMessagesServiceCreateFeedbackResponse>): UIMessagesServiceCreateFeedbackResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UIMessagesServiceCreateFeedbackResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIMessagesServiceCreateFeedbackResponse): UIMessagesServiceCreateFeedbackResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIMessagesServiceCreateFeedbackResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIMessagesServiceCreateFeedbackResponse
 */
export const UIMessagesServiceCreateFeedbackResponse = new UIMessagesServiceCreateFeedbackResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIConversationConfig$Type extends MessageType<UIConversationConfig> {
    constructor() {
        super("c1.api.conversations.v1.UIConversationConfig", [
            { no: 1, name: "admin_agent_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "end_user_agent_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UIConversationConfig>): UIConversationConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.adminAgentUserId = "";
        message.endUserAgentUserId = "";
        if (value !== undefined)
            reflectionMergePartial<UIConversationConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIConversationConfig): UIConversationConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string admin_agent_user_id */ 1:
                    message.adminAgentUserId = reader.string();
                    break;
                case /* string end_user_agent_user_id */ 2:
                    message.endUserAgentUserId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIConversationConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string admin_agent_user_id = 1; */
        if (message.adminAgentUserId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.adminAgentUserId);
        /* string end_user_agent_user_id = 2; */
        if (message.endUserAgentUserId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.endUserAgentUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIConversationConfig
 */
export const UIConversationConfig = new UIConversationConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIConversationsServiceGetConfigRequest$Type extends MessageType<UIConversationsServiceGetConfigRequest> {
    constructor() {
        super("c1.api.conversations.v1.UIConversationsServiceGetConfigRequest", []);
    }
    create(value?: PartialMessage<UIConversationsServiceGetConfigRequest>): UIConversationsServiceGetConfigRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UIConversationsServiceGetConfigRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIConversationsServiceGetConfigRequest): UIConversationsServiceGetConfigRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIConversationsServiceGetConfigRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIConversationsServiceGetConfigRequest
 */
export const UIConversationsServiceGetConfigRequest = new UIConversationsServiceGetConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIConversationsServiceGetConfigResponse$Type extends MessageType<UIConversationsServiceGetConfigResponse> {
    constructor() {
        super("c1.api.conversations.v1.UIConversationsServiceGetConfigResponse", [
            { no: 1, name: "config", kind: "message", T: () => UIConversationConfig }
        ]);
    }
    create(value?: PartialMessage<UIConversationsServiceGetConfigResponse>): UIConversationsServiceGetConfigResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UIConversationsServiceGetConfigResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIConversationsServiceGetConfigResponse): UIConversationsServiceGetConfigResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.conversations.v1.UIConversationConfig config */ 1:
                    message.config = UIConversationConfig.internalBinaryRead(reader, reader.uint32(), options, message.config);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIConversationsServiceGetConfigResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.conversations.v1.UIConversationConfig config = 1; */
        if (message.config)
            UIConversationConfig.internalBinaryWrite(message.config, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIConversationsServiceGetConfigResponse
 */
export const UIConversationsServiceGetConfigResponse = new UIConversationsServiceGetConfigResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIConversationsServiceMutateConfigRequest$Type extends MessageType<UIConversationsServiceMutateConfigRequest> {
    constructor() {
        super("c1.api.conversations.v1.UIConversationsServiceMutateConfigRequest", [
            { no: 1, name: "config", kind: "message", T: () => UIConversationConfig }
        ]);
    }
    create(value?: PartialMessage<UIConversationsServiceMutateConfigRequest>): UIConversationsServiceMutateConfigRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UIConversationsServiceMutateConfigRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIConversationsServiceMutateConfigRequest): UIConversationsServiceMutateConfigRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.conversations.v1.UIConversationConfig config */ 1:
                    message.config = UIConversationConfig.internalBinaryRead(reader, reader.uint32(), options, message.config);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIConversationsServiceMutateConfigRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.conversations.v1.UIConversationConfig config = 1; */
        if (message.config)
            UIConversationConfig.internalBinaryWrite(message.config, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIConversationsServiceMutateConfigRequest
 */
export const UIConversationsServiceMutateConfigRequest = new UIConversationsServiceMutateConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIConversationsServiceMutateConfigResponse$Type extends MessageType<UIConversationsServiceMutateConfigResponse> {
    constructor() {
        super("c1.api.conversations.v1.UIConversationsServiceMutateConfigResponse", [
            { no: 1, name: "config", kind: "message", T: () => UIConversationConfig }
        ]);
    }
    create(value?: PartialMessage<UIConversationsServiceMutateConfigResponse>): UIConversationsServiceMutateConfigResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UIConversationsServiceMutateConfigResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIConversationsServiceMutateConfigResponse): UIConversationsServiceMutateConfigResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.conversations.v1.UIConversationConfig config */ 1:
                    message.config = UIConversationConfig.internalBinaryRead(reader, reader.uint32(), options, message.config);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIConversationsServiceMutateConfigResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.conversations.v1.UIConversationConfig config = 1; */
        if (message.config)
            UIConversationConfig.internalBinaryWrite(message.config, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIConversationsServiceMutateConfigResponse
 */
export const UIConversationsServiceMutateConfigResponse = new UIConversationsServiceMutateConfigResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIConversationsServiceListTicketBindingsRequest$Type extends MessageType<UIConversationsServiceListTicketBindingsRequest> {
    constructor() {
        super("c1.api.conversations.v1.UIConversationsServiceListTicketBindingsRequest", [
            { no: 1, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } }
        ]);
    }
    create(value?: PartialMessage<UIConversationsServiceListTicketBindingsRequest>): UIConversationsServiceListTicketBindingsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.conversationId = "";
        message.pageToken = "";
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial<UIConversationsServiceListTicketBindingsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIConversationsServiceListTicketBindingsRequest): UIConversationsServiceListTicketBindingsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string conversation_id */ 1:
                    message.conversationId = reader.string();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIConversationsServiceListTicketBindingsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string conversation_id = 1; */
        if (message.conversationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.conversationId);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIConversationsServiceListTicketBindingsRequest
 */
export const UIConversationsServiceListTicketBindingsRequest = new UIConversationsServiceListTicketBindingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UIConversationsServiceListTicketBindingsResponse$Type extends MessageType<UIConversationsServiceListTicketBindingsResponse> {
    constructor() {
        super("c1.api.conversations.v1.UIConversationsServiceListTicketBindingsResponse", [
            { no: 1, name: "list", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UIConversationsServiceListTicketBindingsResponse>): UIConversationsServiceListTicketBindingsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<UIConversationsServiceListTicketBindingsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UIConversationsServiceListTicketBindingsResponse): UIConversationsServiceListTicketBindingsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string list */ 1:
                    message.list.push(reader.string());
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UIConversationsServiceListTicketBindingsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string list = 1; */
        for (let i = 0; i < message.list.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.list[i]);
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.conversations.v1.UIConversationsServiceListTicketBindingsResponse
 */
export const UIConversationsServiceListTicketBindingsResponse = new UIConversationsServiceListTicketBindingsResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.conversations.v1.UIConversationsService
 */
export const UIConversationsService = new ServiceType("c1.api.conversations.v1.UIConversationsService", [
    { name: "Create", options: { "authz.method": { role: "EDITOR" } }, I: UIConversationsServiceCreateRequest, O: UIConversationsServiceCreateResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" } }, I: UIConversationsServiceDeleteRequest, O: UIConversationsServiceDeleteResponse },
    { name: "Mutate", options: { "authz.method": { role: "EDITOR" } }, I: UIConversationsServiceMutateRequest, O: UIConversationsServiceMutateResponse },
    { name: "GetConfig", options: { "authz.method": { role: "OWNER" } }, I: UIConversationsServiceGetConfigRequest, O: UIConversationsServiceGetConfigResponse },
    { name: "MutateConfig", options: { "authz.method": { role: "OWNER" } }, I: UIConversationsServiceMutateConfigRequest, O: UIConversationsServiceMutateConfigResponse },
    { name: "ListTicketBindings", options: { "authz.method": { role: "OWNER" } }, I: UIConversationsServiceListTicketBindingsRequest, O: UIConversationsServiceListTicketBindingsResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.conversations.v1.UIConversationsSearchService
 */
export const UIConversationsSearchService = new ServiceType("c1.api.conversations.v1.UIConversationsSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: SearchRequest, O: SearchResponse },
    { name: "GetSearchTerms", options: { "authz.method": { role: "VIEWER" } }, I: GetSearchTermsRequest, O: GetSearchTermsResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.conversations.v1.UIMessagesService
 */
export const UIMessagesService = new ServiceType("c1.api.conversations.v1.UIMessagesService", [
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: UIMessagesServiceListRequest, O: UIMessagesServiceListResponse },
    { name: "Send", options: { "authz.method": { role: "EDITOR" } }, I: UIMessagesServiceSendRequest, O: UIMessagesServiceSendResponse },
    { name: "CreateFeedback", options: { "authz.method": { role: "EDITOR" } }, I: UIMessagesServiceCreateFeedbackRequest, O: UIMessagesServiceCreateFeedbackResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.conversations.v1.UIMessagesSearchService
 */
export const UIMessagesSearchService = new ServiceType("c1.api.conversations.v1.UIMessagesSearchService", [
    { name: "Search", options: { "authz.method": { role: "OWNER" } }, I: UIMessagesSearchServiceSearchRequest, O: UIMessagesSearchServiceSearchResponse }
]);
